<template>
  <div class="scrollBox">
      <pdf v-for="i in numPages" :key="i" :src="pdfSrc" :page="i" ref="wrapper"></pdf>
  </div>
</template>
<script>
import pdf from 'vue-pdf'
export default {
  components:{
      pdf
  },
  data(){
      return {
          pdfSrc:"",
          numPages: null, // pdf 总页数
          scale: 100, //放大系数
      }
  },
  mounted() {
    this.pdfSrc = this.$route.query.url
    this.getNumPages();
  },
  methods: {
    getNumPages() {
      let loadingTask = pdf.createLoadingTask(this.pdfSrc)
      loadingTask.promise.then(pdf => {
        this.numPages = pdf.numPages
      }).catch(err => {
        console.error('pdf 加载失败', err);
      })
    },
    //放大
      scaleD() {
          this.scale += 5;
          // this.$refs.wrapper.$el.style.transform = "scale(" + this.scale + ")";
          this.$refs.wrapper.$el.style.width = parseInt(this.scale) + "%";
      },

      //缩小
      scaleX() {
          if(this.scale == 100) {
              return;
          }
          this.scale += -5;
          this.$refs.wrapper.$el.style.width = parseInt(this.scale) + "%";
          // this.$refs.wrapper.$el.style.transform = "scale(" + this.scale + ")";
      },
  }
}
</script>